<p-card [header]="'MENU.REPORT_STATISTICS' | translate">
  <div class="filter">
    <p-multiSelect
      [(ngModel)]="selectedReportNames"
      (onChange)="setOptions()"
      [filter]="true"
      [options]="reportNames"
      [placeholder]="'REPORT_STATISTICS.SELECT_REPORT' | translate"
      [style]="{ width: '100%' }"></p-multiSelect>
    <p-multiSelect
      [(ngModel)]="selectedMandantNames"
      (onChange)="setOptions()"
      [filter]="true"
      [options]="mandantNames"
      [placeholder]="'REPORT_STATISTICS.SELECT_MANDANT' | translate"
      [style]="{ width: '100%' }"></p-multiSelect>
  </div>
  <div style="width: 100%; height: calc(100vh - 300px); min-height: 100px">
    <app-echart [options]="options"></app-echart>
  </div>
</p-card>
